import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import * as xlsx from "xlsx";
import { ExcursionServiceService } from '../service/excursion-service.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router, NavigationEnd  } from '@angular/router';

@Component({
  selector: 'app-dailyreport',
  templateUrl: './dailyreport.component.html',
  styleUrls: ['./dailyreport.component.css']
})
export class DailyreportComponent implements OnInit {
  @ViewChild('ngSelect')
  ngSelect!: NgSelectComponent;
  reportlist:any=[]
  loading=true
  reportForm=new FormGroup({
    excdate: new FormControl(new Date(), [Validators.required, Validators.minLength(3)]),
    displaytype:new FormControl(1,Validators.required),
    status:new FormControl(0,Validators.required),
  });
  statuslist:any=[
    {"id":0,"value":'Show All'},
    {"id":1,"value":'Pending'},
    {"id":2,"value":'Assigned'},
    {"id":3,"value":'Confirmed'},
    {"id":4,"value":'Cancelled'},
    {"id":5,"value":'Rejected'}
  ];
  display_type:any=[
    {"id":1,"value":'Type 1'},
    {"id":2,"value":'Type 2'}
  ];
  constructor(private excursionServiceService:ExcursionServiceService,private router: Router) { }
  report_serarch_FormSubmit(){
    //console.log(this.reportForm.value)
    if(this.reportForm.value['excdate']!='' && this.reportForm.value['excdate']!=null){
      this.reportForm.value['excdate']=new Date(this.reportForm.value['excdate'])
      this.reportForm.value['excdate']=new Date(this.reportForm.value['excdate'].getTime() - this.reportForm.value['excdate'].getTimezoneOffset()*60000).toISOString();
    }
    this.excursionServiceService.getdaily_Report(this.reportForm.value).subscribe(res=>{
      ////console.log(res)
      // if(this.reportForm.value['excdate']!=''&&this.reportForm.value['excdate']!=null){
      //   this.reportForm.value['excdate']=new Date(this.reportForm.value['excdate'].getTime() - this.reportForm.value['excdate'].getTimezoneOffset()*60000).toISOString();
      // }
      this.loading=false
      if(res['result']==1){
        ////console.log('test') 
        this.reportlist=res['data'][0]
        ////console.log(this.reportlist)
      }
    });
  }
    
  ngOnInit(): void {
    this.loading=false
    window.setTimeout(() => {
      // console.log('setting focus now');
      this.ngSelect.focus();
    }, 10);
  }

  ngAfterViewInit() {
    const cUrl = this.router.url;
    console.log(cUrl);
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.reportlist['xl_report']);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "products");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}